"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Tooltip = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Tooltip"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var _TooltipContent = _interopRequireDefault(require("../TooltipContent"));
var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12zm7-2a1 1 0 0 1 1-1h1a2 2 0 0 1 2 2v4h1a1 1 0 1 1 0 2h-4a1 1 0 1 1 0-2h1v-4h-1a1 1 0 0 1-1-1z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M13 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0z"
  }));
};
InfoIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "sla-tier-label": "OAuthRedirectURIs__sla-tier-label__5d6fD",
  "slaTierLabel": "OAuthRedirectURIs__sla-tier-label__5d6fD",
  "tooltip-icon": "OAuthRedirectURIs__tooltip-icon__1wnHg",
  "tooltipIcon": "OAuthRedirectURIs__tooltip-icon__1wnHg"
}; 
require('./OAuthRedirectURIs.css');
var style = {
  zIndex: 2000
};
var OAuthRedirectURIsLabel = function OAuthRedirectURIsLabel() {
  return /*#__PURE__*/_react.default.createElement("span", {
    className: styles.slaTierLabel
  }, /*#__PURE__*/_react.default.createElement("span", null, "OAuth 2.0 redirect URIs"), /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    position: "right",
    style: style,
    content: /*#__PURE__*/_react.default.createElement(_TooltipContent.default, null)
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: styles.tooltipIcon,
    role: "img",
    "aria-label": "Info OAuth 2.0 redirect URIs",
    "aria-describedby": "info-oauth-tooltip-text",
    size: "xs"
  }, /*#__PURE__*/_react.default.createElement(InfoIcon, null))));
};
var _default = exports.default = OAuthRedirectURIsLabel;
//# sourceMappingURL=OAuthRedirectURIs.js.map